import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type MarketplacesQueryVariables = Types.Exact<{
  first: Types.Scalars['Int']['input'];
}>;


export type MarketplacesQuery = { marketplaces: { edges: Array<{ node: { id: string, pk: number, name: string } }> } };


export const MarketplacesDocument = gql`
    query Marketplaces($first: Int!) {
  marketplaces(first: $first) {
    edges {
      node {
        id
        pk
        name
      }
    }
  }
}
    `;

/**
 * __useMarketplacesQuery__
 *
 * To run a query within a React component, call `useMarketplacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketplacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketplacesQuery({
 *   variables: {
 *      first: // value for 'first'
 *   },
 * });
 */
export function useMarketplacesQuery(baseOptions: Apollo.QueryHookOptions<MarketplacesQuery, MarketplacesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketplacesQuery, MarketplacesQueryVariables>(MarketplacesDocument, options);
      }
export function useMarketplacesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketplacesQuery, MarketplacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketplacesQuery, MarketplacesQueryVariables>(MarketplacesDocument, options);
        }
export type MarketplacesQueryHookResult = ReturnType<typeof useMarketplacesQuery>;
export type MarketplacesLazyQueryHookResult = ReturnType<typeof useMarketplacesLazyQuery>;
export type MarketplacesQueryResult = Apollo.QueryResult<MarketplacesQuery, MarketplacesQueryVariables>;
export function refetchMarketplacesQuery(variables: MarketplacesQueryVariables) {
      return { query: MarketplacesDocument, variables: variables }
    }